import { hasLimits } from "@/utils/permission";
import { localCache } from "@/utils/Cache";
const menuList = {
  state: {
    // imgUrl: `http://${window.location.host}/`,
    imgUrl: `http://cqusms.cqu.edu.cn/`,
    scrollTop: 0,
    funcList: [
      {
        label: "现有预约",
        path: "/currentAppointments",
        name: "currentAppointments",
        icon: require("@/assets/images/home/appointment.png"),
        color: "#E2F7F4",
        permission: "",
        show: true,
        iconShow: true,
      },
      {
        label: "会议预约",
        path: "/meetingReservation",
        name: "meetingReservation",
        icon: require("@/assets/images/home/venueBook.png"),
        color: "#E2F7F4",
        permission: "/meetingReservation",
        show: true,
        iconShow: true,
      },
      {
        label: "活动预约",
        path: "/eventReservation",
        name: "eventReservation",
        icon: require("@/assets/images/home/activity.png"),
        color: "#E2F7F4",
        permission: "/eventReservation",
        show: true,
        iconShow: true,
      },
      {
        label: "预约审核",
        path: "/appointmentReview",
        name: "appointmentReview",
        icon: require("@/assets/images/home/appointmentAudit.png"),
        color: "#E2F7F4",
        permission: "",
        show: false,
        iconShow: true,
      },
      {
        label: "活动报名",
        path: "/joinActivities",
        name: "joinActivities",
        icon: require("@/assets/images/home/joinActivity.png"),
        color: "#E2F7F4",
        permission: "/joinActivities",
        show: true,
        iconShow: true,
      },
      // {
      //   label: "任务回执",
      //   path: "/taskList",
      //   name: "taskList",
      //   icon: require("@/assets/images/home/publishTask.png"),
      //   color: "#E2F7F4",
      //   permission: "/taskList",
      //   show: true,
      //   iconShow: true,
      // },
      {
        label: "我的任务",
        path: "/myTaskList",
        name: "myTaskList",
        icon: require("@/assets/images/home/myTask.png"),
        color: "#E2F7F4",
        permission: "/myTaskList",
        show: true,
        iconShow: true,
      },
      {
        label: "签到扫码",
        path: "/signQRCode",
        name: "signQRCode",
        icon: require("@/assets/images/home/signCode.png"),
        color: "#E2F7F4",
        permission: "vr-front-sign:in-sign",
        show: false,
        iconShow: true,
      },
      {
        label: "签离扫码",
        path: "/signOutQRCode",
        name: "signOutQRCode",
        icon: require("@/assets/images/home/signOut.png"),
        color: "#E2F7F4",
        permission: "vr-front-sign:in-leave",
        show: false,
        iconShow: true,
      },
    ],
    // ownUrl: "http://192.168.0.53:9110/",
    ysxyUrl: "https://www.mingxiaobang.cn/cdysxy/mobile/sccp/",// 艺术学院H5平台
    msxyUrl: "https://www.mingxiaobang.cn/cdmsxy/mobile/sccp/",//美视学院H5平台
    ownUrl: "https://www.mingxiaobang.cn/mobile/sccpPlatform/",// 初始H5平台
    localUrl: "https://www.mingxiaobang.cn/mobileSite/"
  },
  actions: {},
  mutations: {
    setScrollTop(state, n) {
      state.scrollTop = n;
    },
    setMenu(state) {
      const permissionList =
        localCache.getCache("permissionList") &&
        JSON.parse(localCache.getCache("permissionList"));
      if (permissionList?.length) {
        state.funcList?.forEach((item) => {
          if (
            item.path == "/signQRCode" &&
            permissionList?.includes(item.permission)
          ) {
            item.show = true;
          }
          if (
            item.path == "/signOutQRCode" &&
            permissionList?.includes(item.permission)
          ) {
            item.show = true;
          }
          if (
            item.path == "/appointmentReview" &&
            (permissionList?.includes("vr-h5-activity-list") ||
              permissionList?.includes("vr-h5-meeting-list"))
          ) {
            item.show = true;
          }
        });
      }
    },
  },
};

export default menuList;
